import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, Input,
  OnInit, OnDestroy, ViewChild
} from '@angular/core';
import * as _ from 'lodash';


import { SearchModel } from 'shared/search/search.model';

import { BrandService } from 'shared/brand/brand.service';
import { ArchivedProductsSearchService } from './archived-products-search.service';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';
import { LoaderComponent } from 'shared/loader/loader.component';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'archived-products-search',
  templateUrl: 'archived-products-search.component.html',
  styleUrls: ['archived-products-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArchivedProductsSearchComponent extends SearchWidgetComponent implements OnInit, OnDestroy {

  @Input() sortingColumns: Array<any> = [];

  @Input() ghostValue: string = 'archived-products';

  @ViewChild(HiddenScrollComponent, {static: true})
  hiddenScroll: HiddenScrollComponent | void;

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  private isActive: boolean = true;

  get disableItemSelect(): boolean {
    return this.searchModel.selectAll === 'in-list';
  }

  constructor(
    public searchService: ArchivedProductsSearchService,
    protected brandService: BrandService,
    private ref: ChangeDetectorRef,
  ) {
    super(
      brandService,
      searchService,
    );
  }

  ngOnInit() {
    this.searchModel = new SearchModel();
    this.initSubscriptions();
    _.defer(() => this.hiddenScroll && this.hiddenScroll.defineContentWidth());
  }

  ngOnDestroy() {
    this.destroySubscriptions();
    this.isActive = false;
  }

  runSearch(searchModel: SearchModel) {
    if (this.loader) {
      this.loader.show();
    }
    this.ref.markForCheck();
    this.searchService.runSearch(this.brandService.getBrand(), searchModel)
    .pipe(takeWhile(() => this.isActive))
    .subscribe((res: any) => {
      if (this.loader) {
        this.loader.hide();
      }
      this.ref.markForCheck();
    });
  }

  searchByTerm(searchTerm: string): void {
    if (!this.searchModel) {
      return;
    }
    this.searchModel.searchValue = searchTerm;
    this._searchModel.next(this.searchModel);
  }

  updateSearch(): void {
    if (!this.searchModel) {
      return;
    }
    this._searchModel.next(this.searchModel);
  }

  reset(): void {
    this.searchService.deselectAll();
    this.searchService.searchResults = [];
    if (!this.searchModel) {
      return;
    }
    this.searchModel.selectAll = 'on-page';
  }
}
